import * as React from "react";
import { Link as ReactRouterLink, type LinkProps } from "react-router-dom";
import { twMerge } from "tailwind-merge";

export const Link: React.FC<LinkProps> = (props) => {
  const { className, ...rest } = props;

  return (
    <ReactRouterLink
      className={twMerge(
        "text-[#0044CC] underline-offset-4 hover:underline active:no-underline",
        className,
      )}
      {...rest}
    />
  );
};
